"use client"

import dynamic from "next/dynamic"
import { useEffect, useState } from "react"

interface CKEditorProps {
  value: string
  onChange: (data: string) => void
}

// Dynamic import CKEditor component với ssr: false
const CKEditorComponent = dynamic(() => import("./Ckeditor"), {
  ssr: false,
  loading: () => (
    <div className="ckeditor-loading">
      <textarea
        style={{
          width: "100%",
          minHeight: "200px",
          padding: "10px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
        }}
        placeholder="Đang tải editor..."
        readOnly
      />
    </div>
  ),
})

const CKEditorWrapper = ({ value, onChange }: CKEditorProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Render placeholder khi đang ở server-side
  if (!isClient) {
    return (
      <div className="ckeditor-placeholder">
        <textarea
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{
            width: "100%",
            minHeight: "200px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
          }}
          placeholder="Loading editor..."
        />
      </div>
    )
  }

  return <CKEditorComponent value={value} onChange={onChange} />
}

export default CKEditorWrapper
